import { render, staticRenderFns } from "./dietaryDetails.vue?vue&type=template&id=4ee50010&scoped=true&"
import script from "./dietaryDetails.vue?vue&type=script&lang=js&"
export * from "./dietaryDetails.vue?vue&type=script&lang=js&"
import style0 from "./dietaryDetails.vue?vue&type=style&index=0&id=4ee50010&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee50010",
  null
  
)

export default component.exports